<template>
  <div>
    <div class="container pt-0">
      <div class="row">
        <div v-if="isClinius" class="col" :class="{ 'text-center': isClinius }">
          <h1 :class="{ 'fs-40': isClinius }">{{ $t("heading_booking") }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="pane">
            <div class="row">
              <div
                class="col-md-5 pr-lg-5 text-left"
                :class="{ 'border-right': !isMobile }"
              >
                <h2>{{ $t("desired_appointment") }}</h2>
                <termin-zusammenfassung />
              </div>
              <div class="col-md-7">
                <div class="text-center">
                  <div
                    class="fs-40 mt-5"
                    :class="{ 'text-primary': isClinius }"
                  >
                    <font-awesome-icon icon="hourglass-start" />
                  </div>
                  <div
                    id="jumpToBestaetigung"
                    class="mt-3 text-confirm-head"
                    :class="{ 'text-primary': isClinius, 'text-confirm-head-clinius': isClinius }"
                  >
                    {{ $t("fast_geschafft") }}
                  </div>
                  <div class="row mt-5 text-confirm">
                    <div class="col-md-8 offset-md-2">
                      <p
                        class="text-left"
                        v-html="$t('bestaetigung_versendet_1')"
                      />
                    </div>
                    <div class="col-md-8 offset-md-2">
                      <p
                        class="text-left"
                        v-html="$t('bestaetigung_versendet_2')"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import Start from "@/components/Start.vue";

import TerminZusammenfassung from "@/components/TerminZusammenfassung";

export default {
  name: "TerminbestaetigungComponent",
  components: {
    TerminZusammenfassung,
  },
  computed: {
    proposal() {
      return this.$store.state.termin.selectedTermin;
    },
  },
  async mounted(){
    if (this.isMobile) {
      const el = document.getElementById("jumpToBestaetigung");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }
};
</script>
